import React from "react";
import "../Navigation/css/NavBar.scss";

export default function RESTResourceTypes() {
    return (
        <div>
            REST Resource Types
        </div>
    )
}